import { Component, HostBinding } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AppState } from '@core/store';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, tap, filter } from 'rxjs/operators';
import * as oficinasActions from '@core/store/actions/oficinas.actions';
import { currentOffices } from '@core/store/selectors/oficinas.selectors';
import { cargarSistema } from '@core/store/actions/sistema.actions';
import { SciUsuarioOficina } from '~models/config/SciUsuarioOficina';

@Component({
	selector: 'select-office',
	styleUrls: ['./select-office.component.scss'],
	template: `
		<ng-container *ngIf="!(hideOffice$ | async)">
			<ng-container *ngIf="disabledOffice$ | async; else tempButton">
				<div class="d-flex">
					<span class="text-white">{{ oficina.value.nombre ?? 'SELECCIONE OFICINA' }}</span>
				</div>
			</ng-container>
			<ng-template #tempButton>
				<button (click)="selectOffice.open()" class="d-flex align-items-center">
					<span>{{ oficina.value?.nombre ?? 'SELECCIONE OFICINA' }}</span>
					<mat-icon class="d-flex align-items-center">expand_more</mat-icon>
				</button>
			</ng-template>

			<mat-select panelClass="true" #selectOffice class="hidden-select" [formControl]="oficina">
				<mat-option *ngFor="let oficina of oficinas$ | async" [value]="oficina.sciOficina">{{
					oficina.sciOficina.nombre
				}}</mat-option>
			</mat-select>
		</ng-container>
	`,
})
export class SelectOfficeComponent {
	@HostBinding('class') class = 'd-flex align-items-center';

	oficinas$: Observable<SciUsuarioOficina[]> = of();
	hideOffice$: Observable<boolean> = of(false);
	disabledOffice$: Observable<boolean> = of(false);

	oficina = new UntypedFormControl('');

	constructor(private readonly store: Store<AppState>) {}

	ngOnInit(): void {
		this.store.dispatch(cargarSistema());
		this.oficinas$ = this.store.select(currentOffices).pipe(
			filter((loaded) => !!loaded),
			map((usuarioOficinas) => usuarioOficinas),
			tap((oficinas) => {
				if (oficinas && oficinas.length > 0) {
					const ofic = oficinas.find((ofi) => ofi.sciOficina.ctrlOficinaPrincipal).sciOficina;
					this.oficina.patchValue(ofic);
				}
			})
		);

		this.oficina.valueChanges.subscribe((oficina) => {
			this.store.dispatch(oficinasActions.cambiarOficinaSeleccionada({ sciOficina: oficina }));
		});
	}
}
